var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { palette } from '@/theme/palette';
import { Typography } from '@mui/material';
import { AgeSelect } from 'hx-ui';
import { FormNavigationButton, NavigationButton, NavigationButtonsContainer, } from './navigation-button.component';
export function AgeSelectComponent() {
    return (_jsx(StepLayout, { image: pageImages.calendar, showProgress: false, heading: "S\u00E9lectionnez votre", subHeading: "ann\u00E9e de naissance", content: _jsxs("div", __assign({ className: "w-full px-8 flex flex-col h-full justify-between" }, { children: [_jsx("div", __assign({ className: "px-32" }, { children: _jsx(AgeSelect, { minAge: 18, modal: {
                            message: "Ce test de dépistage auditif n'est destiné qu'aux personnes âgées de plus de 18 ans.",
                        }, selectProps: {
                            name: 'birth-year',
                            label: 'Sélectionnez votre année de naissance',
                            className: 'w-full mt-28',
                            variant: 'standard',
                            sx: {
                                '&.MuiInput-underline:before': {
                                    borderBottomColor: palette.primary.main,
                                },
                                '& .MuiSelect-icon': {
                                    color: palette.primary.main,
                                },
                            },
                            showEighteenPlusYearsOnly: true,
                            rules: {
                                required: 'Veuillez sélectionner votre année de naissance',
                                validate: function (value) {
                                    var currentYear = new Date().getFullYear();
                                    var age = currentYear - Number(value);
                                    return age >= 18 || 'Vous devez avoir au moins 18 ans';
                                },
                            },
                        } }) })), _jsxs("div", __assign({ className: "flex flex-col gap-4 w-full max-w-xl/2 mx-auto" }, { children: [_jsx(Typography, __assign({ variant: "caption", className: " font-semibold" }, { children: "Pourquoi indiquer l'ann\u00E9e de naissance?" })), _jsx(Typography, __assign({ variant: "caption" }, { children: "Cette information fournit un contexte essentiel \u00E0 l'exactitude des r\u00E9sultats de votre d\u00E9pistage auditif, car les seuils auditifs varient en fonction de l'\u00E2ge. Ce test de d\u00E9pistage auditif n'est destin\u00E9 qu'aux personnes \u00E2g\u00E9es de plus de 18 ans." }))] }))] })), nav: _jsxs(NavigationButtonsContainer, { children: [_jsx(NavigationButton, { type: "back", variant: "outlined", label: "Pr\u00E9c\u00E9dent", className: "py-2 text-xl" }), _jsx(FormNavigationButton, { type: "submit", variant: "outlined", label: "Suivant", className: "py-2 text-xl" })] }) }));
}
